import ExhibitionStatisticGrid from "./exhibition-statistic-grid";

import "./exhibition-grids.scss";


const ExhibitionGrids = {
    Statistic : ExhibitionStatisticGrid
};

export default ExhibitionGrids;